var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.5C20.4854 19.5 22.5 17.4854 22.5 15C22.5 12.5147 20.4854 10.5 18 10.5C15.5146 10.5 13.5 12.5147 13.5 15C13.5 17.4854 15.5146 19.5 18 19.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32.55C25.95 25.5 30 19.5 30 15C30 11.8174 28.7357 8.76516 26.4854 6.51473C24.2349 4.26428 21.1826 3 18 3C14.8174 3 11.7652 4.26428 9.51473 6.51473C7.26428 8.76516 6 11.8174 6 15C6 19.5 10.05 25.35 18 32.55Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.686a17eff5c4ed655cd959af3ebce283.svg";
export { ForwardRef as ReactComponent };